import { createAction } from "@reduxjs/toolkit";

export const getRoleOptions = createAction("GET_ROLE_OPTION");
